module.exports = __webpack_public_path__ + "img/earth.3fe81b44.png";